<template>
  <div>
    <div id="filter-group">
      <div id="date-filter">
        <label for="">De</label>
        <input type="date" class="form-control custom-width" v-model="filters.startDate">

        <label for="">Até</label>
        <input type="date" class="form-control custom-width" v-model="filters.endDate">

        <button type="button" id="search-button" class="btn mb-0 filter-buttons" @click="getTecnicas()">
          <i class="fa fa-search" aria-hidden="true"></i> Buscar
        </button>

        <button type="button" id="reset-button" class="btn mb-0 filter-buttons" @click="resetFilters()">
          <i class="fa fa-times" aria-hidden="true"></i> Limpar
        </button>
      </div>

      <div class="search-container">
        <input type="text" class="form-control custom-width" placeholder="Pesquisar..." v-model="searchTerm"
          style="width: 100%;">
      </div>

      <div class="d-flex">
        <div class="header-filter">
          <label for="header-filter">Motivo</label>
          <select v-model="reasonFilter" class="form-control custom-width">
            <option value="*" selected>Todos</option>
            <option v-for="reason in reasonsList" :key="reason">{{ reason }}</option>
          </select>
        </div>

        <div class="header-filter">
          <label for="header-filter">Área</label>
          <select v-model="sectorFilter" class="form-control custom-width">
            <option value="*" selected>Todos</option>
            <option value="">Não atribuído</option>
            <option>N2 - Suporte e Gestão de Serviços</option>
          </select>
        </div>

        <div class="header-filter">
          <label for="header-filter">Status</label>
          <select v-model="statusFilter" class="form-control custom-width">
            <option value="*" selected>Todos</option>
            <option>Aberto</option>
            <option>Em andamento</option>
            <option>Fechado</option>
          </select>
        </div>
      </div>
    </div>

    <hr>
    <b-button variant="success" style="margin-right: -4px;" @click="generateExcel">EXCEL <b-icon
        icon="file-earmark-excel" aria-hidden="true"></b-icon></b-button>
    <br>

    <b-row class="justify-content-between" style="overflow-x: auto">
      <b-col md="12">
        <b-table striped hover bordered sort-icon-left show-empty :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
          :items="filteredItems" :fields="fields" :filter="filter" :filter-included-fields="filterOn"
          @filtered="onFiltered" :current-page="currentPage" :per-page="perPage" thead-class="font-weight-bold"
          :sort-compare="sortDate">

          <template #empty="">
            <h6 style="text-align: center">Nenhum resultado encontrado.</h6>
          </template>

          <!-- Formatar campo status -->
          <template #cell(status)="data">
            {{ data.item.status }}
          </template>
          
          <!-- Formatar campo data -->
          <template #cell(created_at)="data">
            {{ moment(data.item.created_at).format('DD/MM/YYYY \à\\s HH:mm') }}
          </template>

          <template #cell(date)="data">
            {{ moment(data.item.date).format('DD/MM/YYYY \à\\s HH:mm') }}
          </template>

          <template #cell(updated_at)="data">
            {{ moment(data.item.updated_at).format('DD/MM/YYYY \à\\s HH:mm') }}
          </template>

          <template #cell(sector)="data">
            {{ data.item.sector || 'Não atribuído' }}
          </template>

          <template #cell(approval)="data">
            {{ capitalizeWord(data.item?.approval ?? "") }}
          </template>

          <template v-slot:cell(view-button)="{ item }">
            <span>
              <b-btn style="background-color: #1c869a" id="view-button" @click.prevent="getTextoOutro(item)">
                <i class="fas fa-eye fa-fw"></i>
              </b-btn>
            </span>
          </template>

        </b-table>

      </b-col>
    </b-row>

    <b-row class="justify-content-between">
      <b-col md="4">
        <b-form-group label="Registros por página" label-for="per-page-select" label-cols-md="6" label-align-sm="right"
          label-size="sm" class="mb-0 align-self-center">
          <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="7" md="6" class="my-1">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" size="md"
          class="my-0"></b-pagination>
      </b-col>
    </b-row>

    <dtModalTecnicas v-if="getlogchat && Object.keys(getlogchat).length" ref="dtModalTecnicas"
      v-on:reload="getTecnicas()" />

  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import moment from 'moment';
import * as XLSX from 'xlsx';

export default {
  props: {
    autoOpenProtocol: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      moment: moment,
      fields: [
        { key: 'protocolo', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'created_at', label: 'Data de Criação', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'created_by', label: 'Criado por', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'updated_at', label: 'Data de Alteração', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'updated_by', label: 'Alterado por', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'operation', label: 'Operação', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'date', label: 'Data do Atendimento', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'routeNumber', label: 'Número da Rota', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'name', label: 'Nome', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'cnpj', label: 'CNPJ', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'nomeCliente', label: 'Cliente', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'nomePonto', label: 'Ponto', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'motivo', label: 'Motivo de Acionamento', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'numberId', label: 'Número do ID', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'atmNumber', label: 'Número do ATM', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'sector', label: 'Área Responsável', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'approval', label: 'Aprovação', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        { key: 'status', label: 'Status', class: 'text-center', thStyle: { backgroundColor: '#1c869a', color: '#ffffff' }, sortable: true },
        {
          key: 'view-button',
          label: 'Visualizar',
          sortable: true,
          class: 'text-center',
          thStyle: { backgroundColor: '#1c869a', color: '#ffffff', width: '100px' }
        }
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, { value: 100, text: "Ver mais" }],
      sortBy: 'created_at',
      sortDesc: false,
      filter: null,
      filterOn: [],
      filters: {
        startDate: '',
        endDate: '',
      },
      searchTerm: '',
      items: [],
      infoModal: {},
      statusFilter: '*',
      sectorFilter: '*',
      reasonFilter: '*',
      autoOpenTriggered: false
    }
  },
  computed: {
    ...mapGetters(['getlogchat']),
    reasonsList() {
      const reasonsArray = []
      this.items.map(el => {
        if (!reasonsArray.includes(el.motivo)) reasonsArray.push(el.motivo)
      })
      return reasonsArray.sort()
    },
    totalRows() {
      return this.filteredItems.length;
    },
    filteredItems() {
      let tempArray = this.items;
      if (this.statusFilter !== '*') tempArray = tempArray.filter(el => el.status === this.statusFilter)
      if (this.sectorFilter !== '*') tempArray = tempArray.filter(el => el.sector === this.sectorFilter)
      if (this.reasonFilter !== '*') tempArray = tempArray.filter(el => el.motivo === this.reasonFilter)
      if (this.searchTerm !== '') tempArray = tempArray.filter(el => {
        const keyword = this.searchTerm.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\w\s]/g, '');
        return [
          el.protocolo,
          el.name,
          el.contato,
          el.cnpj,
          el.razao_social,
          el.created_by,
          el.updated_by,
          el.date,
          el.numberId,
          el.nomeCliente,
          el.nomePonto,
          el.sector,
          el.routeNumber,
          el.atmNumber,
          el.approval,
          el.cidade,
          el.assunto
        ].some(
          field => field && field.toString()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^\w\s]/g, '')
            .includes(keyword)
        );
      })

      return tempArray;
    }
  },
  methods: {
    ...mapMutations(['setLogChat']),
    sortDate(a, b, key) {
      if (key !== 'created_at' && key !== 'updated_at') {
        return null;
      }
      let aDate = moment(a[key], 'YYYY-MM-DD HH:mm:ss')
      let bDate = moment(b[key], 'YYYY-MM-DD HH:mm:ss')
      if (aDate.isValid && bDate.isValid) {
        if (aDate < bDate) {
          return -1
        }
        else if (aDate > bDate) {
          return 1
        }
        else {
          return 0
        }
      }
      return null
    },
    onFiltered(filteredItems) {
      this.currentPage = 1
    },
    async getTextoOutro(item) {
      let survey = {};
      try {
        survey = await axios.get(`/solicitacoes/getSatisfactionDetails/${item.protocolo}`)
          .then(({ data }) => data ?? {});
      } catch (error) {
        console.error(error);
      }

      const outroData = JSON.parse(item.solicitacao)
      const clientData = (item.dados) ? JSON.parse(item.dados) : [];
      const infoModal = {
        tipo_solicitacao: item.requirement_type,
        tipo_atendimento: item.tipo_atendimento,
        id: item.client_id || item.id,
        nome: (outroData.nome || item.name) || 'Não identificado',
        texto: outroData.descricao || outroData.texto,
        contato: this.formTelefone(item?.contato),
        cnpj: item.cnpj || 'Não informado',
        protocolo: item.protocolo,
        date: moment(item.date).format('DD/MM/YYYY \à\\s HH:mm'),
        assunto: outroData.assunto,
        numberId: item.numberId,
        motivo: outroData.motivo,
        status: item.status,
        routeNumber: item.routeNumber,
        atmNumber: item.atmNumber,
        NomeCliente: clientData[0]?.NomeCliente,
        operation: item.operation,
        approval: item?.approval ?? null,
        endereco: clientData[0]?.EnderecoPonto,
        cep: clientData[0]?.CEPCliente,
        nomePonto: clientData[0]?.NomePonto,
        codigoPonto: clientData[0]?.CodigoPonto,
        Base: clientData[0]?.Base,
        created_at: moment(item.created_at).format('DD/MM/YYYY \à\\s HH:mm'),
        updated_at: moment(item.updated_at).format('DD/MM/YYYY \à\\s HH:mm'),
        recordType: item.recordType,
        updated_by: item.updated_by,
        created_by: item.created_by,
        feedback: item.feedback || {},
        type: item.type,
        notes: item.notes || [],
        attachments: item.attachments || [],
        sector: item.sector || '',
        sla: item.sla || ''
      }

      if (infoModal.feedback.updated_at) {
        infoModal.feedback.updated_at = moment(item.feedback.updated_at).format('DD/MM/YYYY \à\\s HH:mm')
      }

      if (Object.keys(survey).length) {
        let avaliacao;
        if (survey.grade === 1) avaliacao = '😫 Péssimo'
        if (survey.grade === 2) avaliacao = '☹️ Ruim'
        if (survey.grade === 3) avaliacao = '😐 Regular'
        if (survey.grade === 4) avaliacao = '🙂 Bom'
        if (survey.grade === 5) avaliacao = '😀 Ótimo'
        const surveyObj = {
          avaliacao,
          reason: survey.reason
        }
        infoModal.survey = surveyObj;
      }

      await this.setLogChat(infoModal);
      this.$refs.dtModalTecnicas.openModal();
    },
    formTelefone(tel) {
      if (!tel) return "";
      tel = tel.replace(/\D/g, "")
      tel = tel.replace(/^(\d)/, "+$1")
      tel = tel.replace(/(.{3})(\d)/, "$1($2")
      tel = tel.replace(/(.{6})(\d)/, "$1)$2")
      if (tel.length == 12) {
        tel = tel.replace(/(.{1})$/, "-$1")
      } else if (tel.length == 13) {
        tel = tel.replace(/(.{2})$/, "-$1")
      } else if (tel.length == 14) {
        tel = tel.replace(/(.{3})$/, "-$1")
      } else if (tel.length == 15) {
        tel = tel.replace(/(.{4})$/, "-$1")
      } else if (tel.length > 15) {
        tel = tel.replace(/(.{4})$/, "-$1")
      }
      tel = tel.replace("(", " (");
      tel = tel.replace(")", ") ");

      return tel;
    },
    getTecnicas() {
      this.items = [];
      let tempArray = [];
      axios.get('/solicitacoes/tecnicas', { params: { start: this.filters.startDate, end: this.filters.endDate } })
        .then(({ data }) => {
          if (data.length > 0) {
            data.forEach(el => {
              if (el.relato) {
                let obj = {
                  'requirement_type': 'outros',
                  'contato': el?.client_id?.substring(0, el.client_id.indexOf('@')),
                  'status': el?.relato?.status,
                  'created_at': el?.created_at,
                  'updated_at': el?.updated_at,
                  'routeNumber': el?.routeNumber,
                  'attachments': el?.attachments,
                  'protocolo': el?.protocol,
                  'dados': JSON.stringify([el?.clientInfo]),
                  'solicitacao': JSON.stringify(el?.relato),
                  'cnpj': el?.cnpj || 'Não informado',
                  'name': (el?.relato?.nome || el?.name) || 'Não identificado',
                  'client_id': el?.client_id,
                  'updated_by': el?.updated_by || '---',
                  'created_by': el?.created_by || '---',
                  'assunto': el?.relato?.assunto,
                  'date': el?.date,
                  'approval': el?.approval ?? null,
                  'numberId': el?.numberId,
                  'atmNumber': el?.relato?.numeroAtm,
                  'operation': el?.operation?.toString()?.toUpperCase() ?? "",
                  'motivo': el?.reason,
                  'recordType': 'mongo',
                  'feedback': el?.feedback,
                  'type': el?.client_id?.includes('whatsapp') ? 'Whatsapp' : 'Formulário',
                  'nomePonto': el?.clientInfo?.NomePonto ? el.clientInfo.NomePonto : 'Não informado',
                  'nomeCliente': el?.clientInfo?.NomeCliente ? el.clientInfo.NomeCliente : 'Não informado',
                  'notes': el?.notes,
                  'sector': el?.sector || '',
                  'sla': el?.sla || ''
                }
                tempArray.push(obj)
              } else {
                let tempObj = { ...el };
                tempObj.feedback = {}
                tempObj.requirement_type = 'outros'
                const dados = JSON.parse(el.solicitacao);
                tempObj.name = dados.nome != '' ? dados.nome : 'Não identificado';
                tempObj.recordType = 'mysql';
                tempObj.updated_by = '---';
                tempArray.push(tempObj);
              }
            })
          }
          this.items = tempArray;
          this.tryAutoOpen();
        })
    },
    resetFilters() {
      this.filters = {
        startDate: '',
        endDate: '',
      }
      this.statusFilter = '*'
      this.searchTerm = ''
      this.sectorFilter = '*'
      this.reasonFilter = '*'
      this.getTecnicas();
    },
    generateExcel() {
      const fieldsExcel = this.filteredItems.map(item => {
        const solicitacao = item.solicitacao ? JSON.parse(item.solicitacao) : {};
        const dadosCampo = item.dados ? JSON.parse(item.dados)[0] : {};
        return {
          'Data de criação': moment(item.created_at).unix(),
          'Criado por': item.created_by,
          'Data de alteração': moment(item.updated_at).unix(),
          'Alterado por': item.updated_by,
          'Protocolo': item.protocolo,
          'Área Responsável': item.sector || 'Não atribuído',
          'Status': item.status,
          'Número da Rota': item.routeNumber,
          'Número do ATM': item.atmNumber,
          'Número do ID': item.numberId,
          'Código Único do Ponto': dadosCampo?.CodigoPonto || "",
          'Tipo': item.client_id.includes('whatsapp') ? 'Whatsapp' : 'Formulário',
          'Nome': (solicitacao.nome || item.name) || 'Não identificado',
          'CNPJ': (!item.cnpj || item.cnpj == '0') ? 'Não informado' : item.cnpj,
          'Base': dadosCampo?.Base || "",
          'Estabelecimento': dadosCampo?.NomePonto || "",
          'Razão Social': dadosCampo?.NomeCliente || "",
          'Endereço': dadosCampo?.EnderecoPonto || "",
          'Assunto': solicitacao.assunto,
          'Data do Atendimento': moment(item.date).unix(),
          'Prazo': item.sla,
          'Descrição': solicitacao.descricao
        }
      }).sort((a, b) => {
        if (a['Data de criação'] < b['Data de criação']) return 1;
        if (a['Data de criação'] > b['Data de criação']) return -1;
      });

      const ordered = fieldsExcel;
      ordered.forEach(el => {
        el['Data de alteração'] = moment.unix(el['Data de alteração']).format('DD/MM/YYYY \à\\s HH:mm')
        el['Data de criação'] = moment.unix(el['Data de criação']).format('DD/MM/YYYY \à\\s HH:mm')
        el['Data do Atendimento'] = moment.unix(el['Data do Atendimento']).format('DD/MM/YYYY \à\\s HH:mm')
      })

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(ordered);
      XLSX.utils.book_append_sheet(wb, ws, "Planilha1");

      XLSX.writeFile(wb, 'Solicitações - Técnicas.xlsx');
    },
    capitalizeWord(str) {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    tryAutoOpen() {
      if (!this.autoOpenProtocol || this.autoOpenTriggered) return;
      const item = this.items.find(el => el.protocolo === this.autoOpenProtocol);
      if (item) {
        this.autoOpenTriggered = true;
        this.getTextoOutro(item);
      }
    },
  },
  mounted() {
    changeTVMode("full")
    if (this.autoOpenProtocol) {
      this.filters.startDate = '';
      this.filters.endDate = '';
    } else {
      this.filters.startDate = moment().startOf('month').format('YYYY-MM-DD');
      this.filters.endDate = moment().format('YYYY-MM-DD');
    }
    this.getTecnicas()
  }
}
</script>

<style scoped lang="scss">
.bgModalHeader {
  background-color: #1c859a;
  color: #FFFFFF;
}

.modal-content {
  border-radius: 3rem;
}

.custom-width {
  width: unset !important;
  border-radius: 10px !important;
}

#filter-group {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

#date-filter {
  display: flex;
  flex: 1;
  align-items: center;
}

.header-filter {
  display: flex;
  align-items: center;
  font-size: small;

  label {
    white-space: nowrap
  }
}

.filter-buttons {
  border-radius: 10px !important;
  font-weight: bold;
  color: white;
  margin-left: 5px;
  padding: 5px 10px;
  transition: 0.2s;
}

#search-button {
  background-color: #1c8498;
  border: 2px solid #1c8498;
  display: flex;
  align-items: center;
  gap: 4px;
}

#search-button:hover {
  background-color: #1c849845;
  color: #1c8498;
}

#reset-button {
  background-color: #e3342f;
  border: 2px solid #e3342f;
  display: flex;
  align-items: center;
  gap: 4px;
}

#reset-button:hover {
  background-color: #e3342f6e;
  color: #e3342f;
}

.search-container {
  width: 100% !important;

  input {
    width: 100% !important;
  }
}

label {
  margin: 0px 10px;
  font-weight: bold;
}
</style>
